import { render, staticRenderFns } from "./ProductHardware.vue?vue&type=template&id=6bf34afa&"
import script from "./ProductHardware.vue?vue&type=script&lang=js&"
export * from "./ProductHardware.vue?vue&type=script&lang=js&"
import style0 from "./ProductHardware.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports